var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg84380(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_84380",
    "data-name": 84380,
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.329,
    height: 14.391,
    viewBox: "0 0 14.329 14.391",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M104.2.485l-.017-.016a1.793,1.793,0,0,0-2.533.115L95.242,7.6a.619.619,0,0,0-.13.222l-.754,2.259a.859.859,0,0,0,.813,1.131h0a.856.856,0,0,0,.345-.073l2.182-.954a.618.618,0,0,0,.209-.15l6.408-7.016A1.8,1.8,0,0,0,104.2.485ZM95.8,9.663l.442-1.326.037-.041.838.765-.037.041Zm7.6-7.479L97.954,8.148l-.838-.765,5.448-5.964a.556.556,0,0,1,.785-.035l.017.016A.556.556,0,0,1,103.4,2.184Z",
    transform: "translate(-90.455)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M13.26,36.644a.619.619,0,0,0-.619.619v5.253a1.575,1.575,0,0,1-1.574,1.574h-7.5a1.575,1.575,0,0,1-1.574-1.574V35.077A1.575,1.575,0,0,1,3.568,33.5H9a.619.619,0,0,0,0-1.238H3.568A2.814,2.814,0,0,0,.757,35.077v7.438a2.814,2.814,0,0,0,2.811,2.811h7.5a2.814,2.814,0,0,0,2.811-2.811V37.262A.619.619,0,0,0,13.26,36.644Z",
    transform: "translate(-0.757 -30.935)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg84380);
export default __webpack_public_path__ + "static/media/84380.91c917bc.svg";
export { ForwardRef as ReactComponent };